module.exports = __webpack_public_path__ + "img/ai_speech.09b7c75a.png";